module.exports = __webpack_public_path__ + "img/good3.befd6e19.png";